import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const CustomDatePicker = ({ name, label, selectedDate, setValue, onChange, explanation, rules, error }) => {
    // State to manage the selected date
    const [currentDate, setCurrentDate] = useState(undefined);

    if (typeof currentDate === "undefined" && selectedDate) {
        setCurrentDate(selectedDate)
    }

    const handleDateChange = (date) => {
        setCurrentDate(date);
        setValue(name, date);
    };

    return (
        <div className="mb-3 flex flex-col w-full">
            <label className='text-brandDarkBlue text-sm font-bold pr-6 mb-1'>{label} {rules && <span className='text-red'>*</span>}</label>
            <DatePicker
                selected={currentDate}
                onChange={handleDateChange}
                className={`bg-white h-12 py-1 px-4 w-full ${error ? 'border border-red focus:outline-red' : ''}`}
            />
            {explanation && (
                <span className='text-brandDarkBlue text-xs text-gray-500 my-1'>{explanation}</span>
            )}
            {error && <span className='text-red text-xs'>{error.message}</span>}
        </div>
    );
};

export default CustomDatePicker;
